<template>
  <v-dialog :model-value="isVisible" @update:model-value="emit('update:isVisible', $event)" max-width="500">
    <v-card>
      <v-card-title class="custom-dialog-title d-flex justify-space-between align-center">
        {{ $t('warning') }}
        <v-btn icon variant="text" @click="emit('update:isVisible', false)">
          <v-icon class="text-white">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="custom-dialog-text">
        <span>{{ $t('help_center_one') }}</span>
        <span>
          <a>{{ $t('help_center_two') }}</a>
        </span>
        <span>{{ $t('help_center_three') }}</span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="custom-btn-grey-auto button-common" flat @click="emit('update:isVisible', false)">
          <span class="font-btn">{{ $t('cancel') }}</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    isVisible: boolean;
  }>(),
  { isVisible: false }
);

const emit = defineEmits<{
  (e: 'update:isVisible', value: boolean): void;
}>();
</script>

<style scoped>
.support-center {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 15rem;
}
.custom-dialog-title {
  background-color: #13795b !important;
  color: white !important;
}
.custom-dialog-text {
  margin: 1rem !important;
}
.font-btn {
  color: white !important;
}
</style>
